<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading" epub:type="z3998:published-works" id="also-by">
<div class="heading heading-container-single heading-size-small heading-format-reduced heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">ALSO BY ROB SINCLAIR</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<p class="first first-in-chapter first-full-width also-by-content"><b><span class="underline"><span class="smallcaps">Ryker Returns Series</span></span></b></p>
<p class="subsq also-by-content"><span class="content-external-link">Renegade</span></p>
<p class="subsq also-by-content"><span class="content-external-link">Assassins</span></p>
<p class="subsq also-by-content"><span class="content-external-link">Outsider</span></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://geni.us/VigilanteRS" target="_blank">Vigilante</a></p>
<p class="subsq also-by-content"><span class="content-external-link">Protector</span></p>
<p class="subsq also-by-content"><span class="content-external-link">Deception</span></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-281">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-rule-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><b><span class="underline"><span class="smallcaps">James Ryker Series</span></span></b></p>
<p class="subsq also-by-content"><span class="content-external-link">The Red Cobra</span></p>
<p class="subsq also-by-content"><span class="content-external-link">The Black Hornet</span></p>
<p class="subsq also-by-content"><span class="content-external-link">The Silver Wolf</span></p>
<p class="subsq also-by-content"><span class="content-external-link">The Green Viper</span></p>
<p class="subsq also-by-content"><span class="content-external-link">The White Scorpion</span></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-281">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-rule-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><b><span class="underline"><span class="smallcaps">The Enemy Series</span></span></b></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://geni.us/DanceWithTheEnemyRS" target="_blank">Dance with the Enemy</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://geni.us/RiseOfTheEnemy" target="_blank">Rise of the Enemy</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://geni.us/HuntForTheEnemyRS" target="_blank">Hunt for the Enemy</a></p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-281">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-rule-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><b><span class="underline"><span class="smallcaps">The Sleeper 13 Series</span></span></b></p>
<p class="subsq also-by-content">Sleeper 13</p>
<p class="subsq also-by-content">Fugitive 13</p>
<p class="subsq also-by-content">Imposter 13</p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-281">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-rule-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><b><span class="underline"><span class="smallcaps">The DI Dani Stephens Series</span></span></b></p>
<p class="subsq also-by-content">The Essence of Evil</p>
<p class="subsq also-by-content">The Rules of Murder</p>
<p class="subsq also-by-content">Echoes of Guilt</p>
<p class="subsq also-by-content">The Bonds of Blood</p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-281">
<img alt="" class="ornamental-break-image" role="presentation" src="images/break-rule-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width also-by-content"><b><span class="underline"><span class="smallcaps">Standalone Thrillers</span></span></b></p>
<p class="subsq also-by-content">Dark Fragments</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsobyrobsinclair.vue?c4451dcc